module.exports = __webpack_public_path__ + "img/seach_selected.e7306b80.png";